<script setup lang="ts">
const reasons = [
  {
    icon: 'pi pi-cloud',
    title: 'Anxiété',
    description:
      "L'anxiété peut se manifester par des inquiétudes persistantes, des tensions, des troubles du sommeil ou un sentiment d'envahissement."
  },
  {
    icon: 'pi pi-moon',
    title: 'Dépression',
    description:
      "La dépression peut entraîner une perte d'élan, de motivation, ou un sentiment de tristesse durable."
  },
  {
    icon: 'pi pi-bolt',
    title: 'Traumatisme',
    description:
      'Certains événements de vie peuvent laisser une empreinte durable. Un accompagnement permet de mieux comprendre et apaiser ces vécus.'
  },
  {
    icon: 'pi pi-compass',
    title: 'Difficultés de vie',
    description:
      'Séparation, problèmes familiaux, professionnels ou maladie peuvent amener à consulter pour être soutenu et retrouver un équilibre.'
  }
]
</script>

<template>
  <section id="services" class="relative overflow-hidden py-24 px-6 md:px-12">
    <div class="absolute inset-0 pointer-events-none" aria-hidden="true">
      <div
        class="dandelion dandelion-3 absolute top-[10%] left-[4%] w-28 h-36 sm:w-36 sm:h-44 -scale-x-100 rotate-[-10deg]" />
      <div class="dandelion dandelion-1 absolute top-[55%] right-[5%] w-24 h-32 sm:w-32 sm:h-40 rotate-[6deg]" />
      <div class="dandelion dandelion-2 absolute bottom-[8%] left-[8%] w-20 h-28 sm:w-24 sm:h-32 rotate-[4deg]" />
    </div>
    <div class="relative max-w-6xl mx-auto flex flex-col gap-12">
      <div class="flex flex-col gap-3 text-center">
        <p class="uppercase tracking-[0.3em] text-sm text-terracotta-600 dark:text-terracotta-400 font-medium">Pourquoi
          consulter&nbsp;?</p>
        <h2 class="text-3xl md:text-4xl text-stone-900 dark:text-stone-50">Quand consulter</h2>
        <p class="text-base md:text-lg text-stone-600 dark:text-stone-400 max-w-2xl mx-auto leading-relaxed">
          On consulte pour des raisons très différentes.
        </p>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div v-for="reason in reasons" :key="reason.title"
          class="card-hover flex flex-col gap-4 p-6 rounded-xl bg-white/70 dark:bg-stone-900/60 border border-stone-200 dark:border-stone-800 backdrop-blur-sm">
          <div
            class="w-12 h-12 rounded-lg bg-terracotta-100 dark:bg-terracotta-900/40 flex items-center justify-center">
            <i :class="reason.icon" class="text-xl text-terracotta-700 dark:text-terracotta-300" aria-hidden="true" />
          </div>
          <h3 class="text-lg text-stone-900 dark:text-stone-50">{{ reason.title }}</h3>
          <p class="text-sm text-stone-600 dark:text-stone-400 leading-relaxed">{{ reason.description }}</p>
        </div>
      </div>
      <div class="max-w-3xl mx-auto text-center flex flex-col gap-3 pt-4">
        <p class="text-base md:text-lg text-stone-600 dark:text-stone-300 leading-relaxed">
          Entreprendre un travail thérapeutique demande à la fois du courage… mais aussi, et peut-être surtout, un désir
          de vie.
        </p>
        <p class="text-lg md:text-xl italic text-terracotta-700 dark:text-terracotta-300 leading-relaxed">
          Croire que la vie peut être vécue plus pleinement.
        </p>
      </div>
    </div>
  </section>
</template>
